import { render } from "./AdminPasswordReset.vue?vue&type=template&id=73af5204&scoped=true"
import script from "./AdminPasswordReset.vue?vue&type=script&lang=js"
export * from "./AdminPasswordReset.vue?vue&type=script&lang=js"

import "./AdminPasswordReset.vue?vue&type=style&index=0&id=73af5204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73af5204"]])

export default __exports__